import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const imageThemeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getImageTheme: builder.query({
      query: ({ patientId, preferredLanguage }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;
        return {
          url: `/api/v1/Patient/${patientId}/image-themes`,
          method: "GET",
          headers,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetImageThemeQuery } = imageThemeApi;
export default imageThemeApi;
